import { render, staticRenderFns } from "./v8.vue?vue&type=template&id=07b6c252&scoped=true&"
import script from "./v8.vue?vue&type=script&lang=js&"
export * from "./v8.vue?vue&type=script&lang=js&"
import style0 from "./v8.vue?vue&type=style&index=0&id=07b6c252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6c252",
  null
  
)

export default component.exports